import React, {Fragment} from 'react';
import PropTypes from "prop-types";
import {Button} from "react-bootstrap";

class EditableText extends React.Component {
    constructor(props) {
        super(props);
        let value = this.props.value ? this.props.value : "";
        this.state = {
            editing: false,
            value: value, // copy over initial value
            rows: 1 // Init with 1, when the focus comes to the field, it resizes
        }
    };

    componentDidUpdate(prevProps, prevState, prevContext) {
        if(this.props.value !== prevProps.value) {
            this.setState({value: this.props.value})
        }
    }

    cancelEdit(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({editing: false, value: this.state.originalValue})
    };

    startEdit(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({editing: true, originalValue: this.state.value})
    }

    confirmEdit(e) {
        e.preventDefault();
        e.stopPropagation();
        this.props.onChange(this.state.value);
        this.setState({editing: false, originalValue: null})
    }
    handleChange(event) {
        const textareaLineHeight = 18;  // must match css

        const previousRows = event.target.rows;
        const currentRows = event.target.scrollHeight / textareaLineHeight;
        if (currentRows === previousRows) {
            event.target.rows = currentRows;
        }

        this.setState({
            value: event.target.value,
            rows: currentRows,
        });
    };

    render() {
        return (
            <td width="25%" onClick={e => this.startEdit(e)}>
                {this.state.editing ? <Fragment>
                        <textarea
                            rows={this.state.rows}
                            value={this.state.value}
                            onFocus={e => this.handleChange(e)}
                            onChange={e => this.handleChange(e)}
                            placeholder={this.props.placeHolder}
                        />
                        <Button onClick={e => this.cancelEdit(e)}>
                            <i className="fas fa-times"/>
                        </Button>

                        <Button onClick={e => this.confirmEdit(e)}>
                            <i className="far fa-save"/>
                        </Button>
                    </Fragment>
                    : <span style={{whiteSpace: 'pre-line'}}>{this.props.value}</span>}
            </td>
        );
    };
}

EditableText.propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    placeHolder: PropTypes.string
};

export default EditableText;


// WEBPACK FOOTER //
// ./src/components/languages/EditableText.js